import React from "react";
import { connect } from "react-redux";
import "./style.scss";

import { update_media_layout } from "../../redux/Conversations/actions";
import ContextMenu from "../../components/ContextMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { CHAT_CENTER_NAME } from "../../constants/app";
import { APP_NAME } from "../../constants/app";
import Logo from "../../assets/logo.png";
import { formatDisplayName } from "../../helpers";
import { enableContext } from "../../auth/secret";

class index extends React.Component {
  state = {
    isHidden: true,
  };
  _handleLogout = () => {
    if (window.confirm("Do you want to logout?")) {
      window.localStorage.removeItem(`${APP_NAME}-authToken`);
      window.location.pathname = `${enableContext ? `/${APP_NAME}` : ""}/login`;
    }
  };

  _handleTriggerContextMenu = () => {
    this.setState({ isHidden: !this.state.isHidden });
  };

  _handleNavigateToMedia = () => {
    this.props.update_media_layout();
    // console.log(`Navigate to media for ${this.props.recipient}`);
  };

  render() {
    const { recipient, conversations } = this.props;
    const currentConversation = conversations.find((conv) => conv.sender === recipient);
    const fullName = currentConversation?.fullName;

    const displayName = formatDisplayName(fullName, recipient);
    return (
      <div className="ut-top-navbar ut-border">
        <ContextMenu trigger={this._handleTriggerContextMenu} hidden={this.state.isHidden} top={40} right={10}>
          <div className="ut-context-item" onClick={this._handleLogout}>
            Logout
          </div>
        </ContextMenu>
        <div className="ut-d-flex ut-align-items-center">
          <img src={Logo} alt="app-logo" style={{ height: 30, marginLeft: 10, borderRadius: 10 }} />
          <span style={{ fontSize: 18, paddingLeft: 10, fontWeight: 600 }}>{CHAT_CENTER_NAME}</span>
        </div>
        <div className="ut-d-flex ut-align-items-center ut-justify-content-space-between" style={{ padding: "0 10px" }}>
          <span onClick={this._handleNavigateToMedia} style={{ cursor: "pointer" }}>
            <b>{displayName}</b>
          </span>
          <div className="ut-d-flex ut-align-items-center ut-justify-content-end" style={{ flex: 1 }}>
            <FontAwesomeIcon style={{ cursor: "pointer" }} onClick={this._handleTriggerContextMenu} className="ut-color-primary" size="lg" icon={faEllipsisV} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  recipient: state.Conversation.recipient,
  conversations: state.Conversation.conversations,
});

export default connect(mapStateToProps, { update_media_layout })(index);
